import { TSentryEnv } from "./sentry-env.type";

export const sentryEnv: TSentryEnv = {
  enabled: false,
};
